import apiClient from '@/services/apiClient';

export const GENDERS = [{ value: 'male', label: 'Male' }, { value: 'female', label: 'Female' }];
export const WORKER_TYPES = [{ value: 'regular', label: 'Regular' }, { value: 'contract', label: 'Contract' }];
export const COLLARS = [{ value: 'white', label: 'White Collar' }, { value: 'blue', label: 'Blue Collar' }];
export const PAY_TYPES = [{ value: 'fixed', label: 'Fixed' }, { value: 'variable', label: 'Variable' }];
export const ROLL_STATUSES = [{ value: 'in_roll', label: 'In Roll' }, { value: 'left', label: 'Left' }];
export const labelOf = (list, v) => list.find((o) => o.value === v)?.label || '';

export const TEMPLATE_HEADERS = [
  'staff_id', 'staff_name', 'designation', 'section', 'dob (YYYY-MM-DD)', 'doj (YYYY-MM-DD)',
  'gender (Male/Female)', 'worker_type (Regular/Contract)', 'collar (White/Blue)', 'agency', 'pay_type (Fixed/Variable)', 'fixed_pay (Rs per month)', 'roll_status (In Roll/Left)', 'left_date (YYYY-MM-DD)', 'phone', 'essl_code',
];

// Mirrors backend require_staff_editor (Admin / Site Admin / HR Manager / HR tick / staff-master grant).
export const canEditStaff = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    const role = (u.role || '').trim().toLowerCase();
    if (['admin', 'super_admin', 'super admin', 'site admin', 'hr manager'].includes(role)) return true;
    const ops = u.allowed_operations || {};
    const panel = ops.admin_panel || [];
    return (ops.staff_attendance || []).includes('satt-hr') || panel.includes('staff-attendance-admin') || panel.includes('staff-master');
  } catch {
    return false;
  }
};

const clean = (params) => Object.fromEntries(Object.entries(params).filter(([, v]) => v));

const saveBlob = (data, name) => {
  const url = URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url; a.download = name; a.click();
  URL.revokeObjectURL(url);
};

export const staffMasterApi = {
  list: (params) => apiClient.get('/staff/list', { params: clean(params) }).then((r) => r.data),
  create: (body) => apiClient.post('/staff/create', body).then((r) => r.data),
  update: (staffId, body) => apiClient.put(`/staff/update/${encodeURIComponent(staffId)}`, body).then((r) => r.data),
  history: (staffId) => apiClient.get(`/staff/history/${encodeURIComponent(staffId)}`).then((r) => r.data.history),
  exportCsv: async (params) => {
    const r = await apiClient.get('/staff/export', { params: clean(params), responseType: 'blob' });
    saveBlob(r.data, `staff_master_${new Date().toISOString().slice(0, 10)}.csv`);
  },
  downloadTemplate: () => saveBlob(`${TEMPLATE_HEADERS.join(',')}\n`, 'staff_master_template.csv'),
  // XHR (not fetch) so the multipart body survives the platform fetch wrappers; parses the SSE progress stream.
  importCsv: (file, onProgress) => new Promise((resolve, reject) => {
    const form = new FormData();
    form.append('file', file);
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${process.env.REACT_APP_BACKEND_URL}/api/staff/import`, true);
    xhr.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('session_token')}`);
    xhr.setRequestHeader('X-Site-Id', localStorage.getItem('active_site_id') || 'salem');
    let last = null;
    const parse = () => {
      (xhr.responseText || '').split('\n').filter((l) => l.startsWith('data: ')).forEach((l) => {
        try { last = JSON.parse(l.slice(6)); } catch { /* partial chunk */ }
      });
      if (last) onProgress?.(last);
    };
    xhr.onprogress = parse;
    xhr.onload = () => {
      parse();
      if (xhr.status >= 300) {
        let msg = `Import failed (HTTP ${xhr.status})`;
        try { msg = JSON.parse(xhr.responseText).detail || msg; } catch { /* not json */ }
        reject(new Error(msg));
      } else if (last?.error) reject(new Error(last.error));
      else resolve(last);
    };
    xhr.onerror = () => reject(new Error('Network error during import'));
    xhr.send(form);
  }),
};
